import { Box } from "@mui/material";
import styled from "styled-components";

export const UserInfoFormStyled = styled(Box)`
  .userName {
    padding-bottom: 24px;
  }
  .userNameCreate {
    padding-bottom: 16px;
  }

  .creation-template {
    margin: 16px;
  }
  .detail-template {
    display: grid;
    grid-template-columns: 60% calc(40% - 16px);
    gap: 16px;
  }
  .flex {
    display: flex;
    gap: 16px;
    padding-bottom: 24px;
  }

  .flexCreate {
    display: flex;
    gap: 10px;
    padding-bottom: 16px;
  }
  .gridAddress {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .gridAddressCreate {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .user-cont {
    display: flex;
    flex-direction: column;
    padding: 0px;
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 10px;
    column-gap: 20px;
  }

  .row-style {
    min-height: ${(props) => (props?.isGroupDetailView ? "87px" : "150px")};
    border-radius: 5px;
  }

  .checkbox-wrapper {
    display: flex;
    gap: 10px;
    margin-top: 30px;
    margin-left: 12px;

    .MuiFormControlLabel-root {
      height: 35px;
      border: 1px solid rgba(0, 0, 0, 0.23);
      border-radius: 4px;
      width: 50%;
      background-color: white;
    }
  }
  .hr {
    border: 1px solid #dedafb;
    margin: 10px 0px 10px 0px;
  }
  .scheduleStart {
    display: grid;
    grid-template-columns: calc(75% - 16px) 25%;
    gap: 8px;
  }
  .left-content {
    display: flex;
    flex-direction: column;
  }
`;
